export const NOTARY_SPACES = [
  {
    name: "espacenotarial",
    url: "https://espacenotarial.com",
  },
];
